import React from 'react';
import { ReactComponent as IconGoogle } from '../../media/icons/logo_google.svg';

export default class GoogleAuthButton extends React.Component {
  handleClick = () => {
    const params = new URLSearchParams({
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      redirect_uri: `${window.location.origin}/signup/oauth2/callback`,
      response_type: 'code',
      scope: 'openid profile email',
      prompt: 'select_account'
    });
    window.location = `https://accounts.google.com/o/oauth2/v2/auth?${params}`;
  };

  render() {
    return (
      <div onClick={this.handleClick} className="form__content__buttonbox__button button button-grey form__content__buttonbox__button--oauth-container">
        <IconGoogle className="form__content__buttonbox__button__logo" />
        <div className="form__content__buttonbox__button__label">
          {this.props.label}
        </div>
      </div>
    );
  }
}
